export default function objFilterUndefined<
  O extends Record<string, string | undefined>
>(obj: O) {
  return Object.fromEntries(
    Object.entries(obj).filter((e): e is [string, string] => e[1] !== undefined)
  )
}
